import { QUALIFICATION_KEY_TYPE } from "@/shared/model";
import { z } from "zod";

const schema = z.object({
	department: z.string(),
	salesSummaryType: QUALIFICATION_KEY_TYPE,
	target: z.number(),
	actual: z.number(),
	ratio: z.number(),
	ratioOfContribution: z.number(),
});

const model = schema.transform((values) => ({
	...values
}));

export const TeamSummaryModel = { schema, model };
export type ITeamSummaryModel = z.infer<typeof TeamSummaryModel.model>;
export const DEFAULT_TEAM_SUMMARY: ITeamSummaryModel = {
	department: "",
	salesSummaryType: "NORMAL_INSURANCE",
	target: 0,
	actual: 0,
	ratio: 0,
	ratioOfContribution: 0
};
